/** Network + geolocation helpers. Kept isolated so tests can mock cleanly. */
import { listPending, getMeta, setMeta } from "./db";

export function isOnline() {
  return navigator.onLine !== false;
}

export function getGPS() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("Geolocation unsupported"));
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy }),
      (err) => reject(err),
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 }
    );
  });
}

// 9AM stale check — fires a browser Notification (if permitted) when re-opening
// the app with pending records older than 24h past 09:00 local. At most once/day.
export async function fireStaleNotifIfDue() {
  try {
    const items = await listPending();
    if (!items.length) return;
    const oldest = items.reduce((a, b) => (a.queued_at < b.queued_at ? a : b)).queued_at;
    const ageH = (Date.now() - new Date(oldest).getTime()) / 3.6e6;
    if (ageH < 24) return;
    const now = new Date();
    if (now.getHours() < 9) return;
    const last = await getMeta("last_stale_notif_date");
    const today = now.toISOString().slice(0, 10);
    if (last === today) return;
    if ("Notification" in window) {
      if (Notification.permission === "default") {
        try { await Notification.requestPermission(); }
        catch (e) { console.debug("[offline] notification permission denied:", e?.message); }
      }
      if (Notification.permission === "granted") {
        new Notification("HAG Carpets — pending inspections", {
          body: `${items.length} inspection(s) still not synced. Please connect and sync.`,
        });
      }
    }
    await setMeta("last_stale_notif_date", today);
  } catch (e) {
    console.debug("[offline] stale-notif check failed:", e?.message);
  }
}
